"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _StyledLayout = require("../../../StyledLayout");

var _SocialGroup = _interopRequireDefault(require("../components/SocialGroup"));

var _helpers = require("../helpers");

var _Elements = require("./Elements");

var UnPublishSite = function UnPublishSite(_ref) {
  var cover = _ref.cover,
      title = _ref.title,
      socialMedia = _ref.socialMedia,
      deactivatedMessage = _ref.deactivatedMessage,
      visibilityOptions = _ref.visibilityOptions;
  var coverPhotoUrl = (0, _helpers.getCoverPhotoUrl)(cover);

  var message = deactivatedMessage || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.unpublish.prompt"
  });

  return /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, null, /*#__PURE__*/_react["default"].createElement(_Elements.CoverPhoto, null, coverPhotoUrl && /*#__PURE__*/_react["default"].createElement(_Elements.Image, {
    src: coverPhotoUrl,
    alt: "title"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.StyledUnPublishWrapperBox, {
    flex: true,
    justify: "center",
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Elements.StyledUnPublishBox, {
    flex: true,
    column: true,
    align: "center",
    justify: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Elements.UnpublishedTitle, {
    center: true,
    mb: "sm",
    bold: true
  }, title.toLocaleUpperCase()), /*#__PURE__*/_react["default"].createElement(_Elements.UnpublishedParagraph, null, message), /*#__PURE__*/_react["default"].createElement(_SocialGroup["default"], {
    socialMedia: socialMedia,
    visibilityOptions: visibilityOptions
  }))));
};

UnPublishSite.defaultProps = {
  cover: '',
  title: 'wuxio.io',
  deactivatedMessage: null,
  socialMedia: {
    website: '',
    instagram: '',
    facebook: '',
    twitter: ''
  },
  visibilityOptions: {
    location: 'VISIBLE',
    pxProfile: 'VISIBLE',
    instagram: 'VISIBLE',
    facebook: 'VISIBLE',
    twitter: 'VISIBLE'
  }
};
UnPublishSite.propTypes = {
  cover: _propTypes["default"].shape(),
  title: _propTypes["default"].string,
  deactivatedMessage: _propTypes["default"].string,
  socialMedia: _propTypes["default"].shape({
    website: _propTypes["default"].string,
    instagram: _propTypes["default"].string,
    facebook: _propTypes["default"].string,
    twitter: _propTypes["default"].string
  }),
  visibilityOptions: _propTypes["default"].shape({
    location: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN']),
    pxProfile: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN']),
    instagram: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN']),
    facebook: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN']),
    twitter: _propTypes["default"].oneOf(['VISIBLE', 'HIDDEN'])
  })
};
var _default = UnPublishSite;
exports["default"] = _default;